import { useState } from "react";

export function useSearch() {
    const [searchTerm, setSearchTerm] = useState([]);
    const [searchShown, setSearchShown] = useState(true);
    return { searchTerm, setSearchTerm, searchShown, setSearchShown };
}